var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "search-wrap" }, [
    _c(
      "form",
      {
        attrs: {
          id: "searchform",
          action: "/v",
          method: "get",
          "accept-charset": "utf-8",
        },
        on: { submit: _vm.submitEvent },
      },
      [
        _c("div", { staticClass: "search-box", attrs: { id: "searchBox" } }, [
          _c("div", { staticClass: "query-box" }, [
            _c("input", {
              attrs: { type: "hidden", name: "w", value: "06009900" },
            }),
            _vm._v(" "),
            _c("input", {
              attrs: { type: "hidden", name: "ie", value: "utf8" },
            }),
            _vm._v(" "),
            _vm.spver === 1
              ? _c("input", {
                  attrs: { type: "hidden", name: "spver", value: "1" },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.query,
                  expression: "query",
                },
              ],
              staticClass: "query",
              attrs: {
                id: "keyword",
                type: "search",
                placeholder: "搜一搜，发现精彩视频",
                name: "query",
                autocomplete: "off",
                maxlength: "100",
                autocorrect: "off",
                autocapitalize: "off",
                uigs: "home_input",
              },
              domProps: { value: _vm.query },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.query = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.query,
                  expression: "query",
                },
              ],
              staticClass: "search-del",
              attrs: { uigs: "home_reset" },
              on: { click: _vm.resetEvent },
            }),
            _vm._v(" "),
            _vm._m(0),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "search" }, [
      _c("input", {
        attrs: { type: "submit", value: "搜索", uigs: "home_submit" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }